import { gql } from '__generated__';

export default gql(`
  mutation ExportContacts($input: ExportParticipantsInput!) {
    exportParticipants(input: $input) {
      id
    }
  }
`);
